import { render, staticRenderFns } from "./DeleteRole.vue?vue&type=template&id=398045fe&scoped=true&"
import script from "./DeleteRole.vue?vue&type=script&lang=js&"
export * from "./DeleteRole.vue?vue&type=script&lang=js&"
import style0 from "./DeleteRole.vue?vue&type=style&index=0&id=398045fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398045fe",
  null
  
)

export default component.exports